/**
 * A generic static (singleton) class:
 * Manage global event bus
 * Handles resize, scroll, stopScroll events
 * Keeps viewport dimensions
 * Keeps scroll position
 * Keeps references to important DOM elements
 */

import { nanoid } from 'nanoid'

// TODO: Split to smaller classes (eg U.math, U.obj, U.str)
import EVENT from './event'

import './util/MODULE'
import './util/ANIM'

window.BUS = {};
let scrollFrame;

let Z = {

    // viewport state
    vw: 0,
    vh: 0,
    vw2: 0,
    vh2: 0,
    vr: 0, // viewport aspect ratio

    // elements
    $html: $("html"),
    $body: $("body"),
    timer: null,
    baseURL: null,

    OBSERVER: "IntersectionObserver" in window,

    init (app) {
        if (Z.initialized) return;
        Z.initialized = 1;
        Z.baseURL = window.location.origin;

        Z.html = Z.$html[0];
        Z.body = Z.$body[0];
        // Z.scrollContainer = window;

        if (is.touchDevice()) Z.$html.addClass('touch');
        if (is.ipad()) Z.$html.addClass('ipad');
        if (is.ios()) Z.$html.addClass('ios');
        window.addEventListener("scroll", Z.onScroll);
        window.addEventListener("resize", Z.onResize);
        window.addEventListener("orientationchange", Z.onResize);

        // general events
        Z.on("ScrollToTarget", target => Z.scrollTo(target));

        Z.onStopResize = Z.debounce(() => Z.emit('AppResize'), 500);
        Z.onStopScroll = Z.debounce(() => requestAnimationFrame(() => Z.emit(EVENT.StopScroll)), 250);
        Z.onResize();
        Z.setScrollState();
        if (app) app.init();
        $('img').one('load', () => Z.emit("ImageLoad"));
    },

    ready () {
        window.dispatchEvent(new CustomEvent("APP_READY"));
    },

    // page properties
    initPage () {
        let path = location.pathname;
        Z.isHome = path == "/" || path == "/home";
        Z.url = window.location.href;
    },

    freezeVp: e => e.preventDefault(),
    getID: () => 'uuid.' + nanoid(),

    isHome () {
        let { origin, href } = window.location;
        return origin == href || origin + '/' == href;
    },

    // MouseMove

    //resize --------------------------------------------
    onResize (e) {
        if (e) e.preventDefault();
        Z.vw = window.innerWidth;
        Z.vh = window.innerHeight;
        Z.vw2 = Z.vw / 2;
        Z.vh2 = Z.vh / 2;
        Z.vr = Z.vw / Z.vh;
        // use this for the footer
        Z.$body.toggleClass('overflowed', Z.vh > Z.$html.height());
        Z.onStopResize();
    },

    //scroll --------------------------------------------
    onScroll () {
        Z.onStopScroll();
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(Z.scrollEvent);
    },
    scrollEvent () {
        Z.setScrollState();
        // Z.emit('onAppScroll');
        Z.emit('AppScroll', {
            scrollTop: Z.scrollY,
            scrollHeight: Z.scrollHeight,
            offsetHeight: Z.body.offsetHeight,
            scrollPercentage: Z.scrollPercY
        });
    },
    setScrollState () {
        let scrollY = window.scrollY;
        Z.scrollX = window.scrollX;
        Z.scrollWidth = Z.body.scrollWidth;
        Z.scrollHeight = Z.body.scrollHeight;
        Z.scrollDown = scrollY > Z.scrollY;
        Z.scrollY = scrollY;
        Z.scrollPercY = scrollY / (Z.scrollHeight - Z.vh) * 100;
        Z.scrollEndY = scrollY + Z.vh >= Z.scrollHeight;
    },


    // TODO: Harry: find all occurancies and keep only the css or class method
    enableScroll () {
        Z.$html.removeClass('noscroll');
        Z.$body.removeClass('noscroll');
    },
    disableScroll () {
        Z.$html.addClass('noscroll');
        Z.$body.addClass('noscroll');
    },

    // EVENT management ----------------------------------------------------------------
    // TODO: Harry: Create a more clean BUS to watch and add "once" method
    emit (e, param) {
        Z.checkEvent(e);
        if (!BUS[e]) return;
        for (let token in BUS[e]) BUS[e][token](param);
    },
    // TODO: Harry: check if there are registration to resize/scroll to stop/start the listeners
    on (e, callback) {
        Z.checkEvent(e);
        if (!BUS[e]) BUS[e] = {};
        BUS[e][nanoid()] = callback;
    },
    off (e, callback) {
        Z.checkEvent(e);
        if (!BUS[e]) return;
        for (let token in BUS[e]) {
            if (BUS[e][token] == callback) {
                delete BUS[e][token];
                // TODO: Harry: Magazine problem destroying modules. Fix & uncomment next lines
                // if (!Object.keys(BUS[e]).length) {
                // 	delete BUS[e];
                // }
                return;
            }
        }
    },
    eventExists: e => EVENT.hasOwnProperty(e) || EVENT.hasOwnProperty(/[^;\-\.]*/.exec(e)[0]),
    checkEvent: e => { if (!Z.eventExists(e)) console.error('Undefined EVENT: ' + e) },

    // String ----------------------------------------------------------------------------
    capitalizeFirst: str => str.charAt(0).toUpperCase() + str.substring(1),
    toCamel: s => s.replace(/([-_][a-z])/ig, ($1) => $1.toUpperCase().replace('-', '').replace('_', '')),

    // Decamelizes a string with/without a custom separator (dash by default).
    decamelize: (str, separator = '-') => str.replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
        .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
        .toLowerCase(),
    getFirstMatch: (str, reg) => (str.match(reg) || []).shift(),
    getFirstChar: str => Z.getFirstMatch(str, /[A-Za-z]/g),
    str2Int: str => str ? parseInt(str.match(/\d+/g)[0]) : 0,
    splitCommas: str => str.split(/[\s,]+/),

    hasStableConnection () {
        let conn = navigator.connection;
        return conn && (conn.type == 'wifi' || conn.type == 'ethernet');
    },

    debounce (fn, duration = 0) {
        let timer;
        return function () {
            const functionCall = () => fn.apply(this, arguments);
            clearTimeout(timer);
            timer = setTimeout(functionCall, duration);
        }
    },

    // Math ------------------------------------------------------------------------------
    rand: (min, max) => min + Math.random() * (max - min),
    randInt: (min, max) => Math.floor(Z.rand(min, max + 1)),
    clamp: (number, min, max) => Math.max(min, Math.min(number, max)),
    getInt (num) {
        let n = parseInt(num, 10);
        return isNaN(n) ? 0 : n;
    },

    lin (x, o) {
        let { start, end, min, max } = o;
        return x <= start ? min : x >= end ? max : min + (x - start) / (end - start) * (max - min);
    },
    sin (x, o) {
        let { start, end, min, max } = o;
        return x <= start ? min : x >= end ? max : min + Math.sin((x - start) / (end - start) * Math.PI / 2) * (max - min);
    },

    // Transform shorthands ---------------------------------------
    trans (o, el) {
        if (o.scale) o.sx = o.sy = o.scale;
        o = Object.assign({ x: 0, y: 0, sx: 1, sy: 1, r: 0 }, o);
        Z.transSet(el, Z.transT(o.x, o.y) + " " + Z.transS(o.sx, o.sy));
    },
    transSet: (el, tr) => (el ? (el.style.transform = tr) : tr),
    transTS: (x, y, sx, sy, el) => Z.transSet(el, Z.trans(x, y) + " " + Z.transS(sx, sy)),
    transT (x, y, el) {
        if (!isNaN(x)) x = x + "px";
        if (!isNaN(y)) y = y + "px";
        return Z.transSet(el, "translate3d(" + x + "," + y + ",0)");
    },
    transS: (sx, sy) => "scale(" + sx + ", " + sy + ")",

    transition: (tr, ...els) => els.forEach(el => (el.style.transition = tr)),
    resetTransform: (...ar) => ar.forEach(el => el.style.transform = ""),
    translate: (el, x, y) => el.style.transform = 'translate3d(' + x + ',' + y + ',0)',
    clearStyle: (...ar) => ar.forEach(el => el.removeAttribute("style")),

    onLoadImages (container, callback) {
        let loaded = 0,
            imgs = $(container).find('img');
        if (imgs.length) {
            imgs.on('load', () => { if (++loaded == imgs.length) callback(); })
        } else {
            callback();
        }
    }

};

window.Z = Z;
export default Z;
